import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Schedule } from '../../elements-forms/schedule';

export const BookingDetailsReview = ({ booking, alcoholConsumed }) => {
  return (
    <div data-testing-id="booking-details-review">
      <div className='padding-lg-bottom'>
        <p className='text-base heavier margin-sm-bottom'>
          <FormattedMessage
            id='inbox.review_update.date_and_time'
            defaultMessage='Date and time'
          />
        </p>
        <Schedule
          timeZoneId={
            booking?.timezone ? booking?.timezone.id : 'America/Los_Angeles'
          }
          schedule={booking?.schedule}
        />
      </div>
      <div className='padding-lg-bottom padding-lg-top'>
        <p className='text-base heavier margin-sm-bottom'>
          <FormattedMessage
            id='inbox.review_update.attendees'
            defaultMessage='Attendees'
          />
        </p>
        <span data-testing-id="attendees">{booking?.attendees || '0'}</span>
      </div>
      <div className='padding-lg-bottom padding-lg-top'>
        <p className='text-base heavier margin-sm-bottom'>
          <FormattedMessage
            id='inbox.review_update.activity'
            defaultMessage='Activity'
          />
        </p>
        <span data-testing-id="activity">{booking?.tags?.activity}</span>
      </div>
      <div className='padding-lg-top'>
        <p className='text-base heavier margin-sm-bottom'>
          <FormattedMessage
            id='inbox.review_update.alcohol_consumed'
            defaultMessage='Alcohol consumed'
          />
        </p>
        <span data-testing-id="alcohol-consumed">
          {alcoholConsumed ? (
            <FormattedMessage
              id='inbox.review_update.alcohol_consumed_yes'
              defaultMessage='Yes'
            />
          ) : (
            <FormattedMessage
              id='inbox.review_update.alcohol_consumed_no'
              defaultMessage='No'
            />
          )}
        </span>
      </div>
    </div>
  );
};
